// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Attachment } from './attachment';
import { CustomerTaxCode } from './customer-tax-code';
import { CustomerType } from './customer-type';
import { InvoicePaymentMethod } from './invoice-payment-method';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Customer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
        let name = '';
        if (this.typeId == CustomerType.Types.Contractor) name = this.companyName;
        else {
            if (this.companyName) name = this.companyName;
            else if (!this.firstName && !this.lastName) name = '(retail names blank)';
            else name = [this.firstName, this.lastName].join(' ');
        }
        return name;
    }

    get codeDisplayName() {
        return `${this.customerUnixKey ?? ''} --- ${this.companyName ?? ''}`;
    }
    get hasEmail() {
        return !!this.email && this.email.length > 0;
    }
    hasActiveProductPriceOverride = false;
    openBalance = 0;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billAddress1?: string;
  billAddress2?: string;
  billCity?: string;
  billCountry?: string;
  billState?: string;
  billZip?: string;
  companyName?: string;
  contactName?: string;
  created!: Date;
  createdBy?: string;
  customerUnixKey?: string;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  fax?: string;
  firstName?: string;
  lastName?: string;
  notes?: string;
  paymentMethodId?: number;
  phone?: string;
  preferredCommunication?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  requirePoOnInvoices!: boolean;
  salesRep?: string;
  taxCodeId?: number;
  taxCodeString?: string;
  terms?: string;
  typeId!: number;
  attachments!: Attachment[];
  paymentMethod!: InvoicePaymentMethod;
  taxCode!: CustomerTaxCode;
  type!: CustomerType;
}

